import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AboutMe from "./components/AboutMe/AboutMe";
import Articles from "./components/Articles/Articles";
import ReadingPage from "./components/ReadingPage/ReadingPage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<AboutMe />} />
        <Route path="articles" element={<Articles />} />
        <Route path="resume" element={<AboutMe />} />
        <Route path="quotes" element={<AboutMe />} />
        <Route path="test" element={<ReadingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
